import { render } from "./IconValues.vue?vue&type=template&id=673a6746"
const script = {}

import exportComponent from "/builds/sats/careers-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__